import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { apiRequest, fetchJson } from "@/lib/queryClient";
import { useAuth } from "@/lib/auth-context";
import { podeFazer } from "@/lib/permissoes";
import type { AcessoSuporteDTO } from "@/hooks/use-plataforma";

const CHAVE = "/api/organizations/me/acessos-suporte";

/**
 * O lado do ADMIN da org: pedidos PENDENTES e acessos AUTORIZADOS vigentes do
 * suporte do Rizoma. Só consulta quem gere usuários (`org.usuarios`) e fora do
 * modo suporte — ninguém mais tem o que autorizar.
 */
export function useAcessosSuporte() {
  const { user } = useAuth();
  const ativo = !!user && !user.suporte && podeFazer(user.role, "org.usuarios");
  return useQuery<AcessoSuporteDTO[]>({
    queryKey: [CHAVE],
    queryFn: () => fetchJson<AcessoSuporteDTO[]>(CHAVE),
    enabled: ativo,
    // O cartão precisa aparecer sem reload quando o pedido chega.
    refetchInterval: ativo ? 60_000 : false,
  });
}

export function useResponderAcessoSuporte() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id, acao }: { id: string; acao: "autorizar" | "recusar" | "encerrar" }) =>
      apiRequest("POST", `${CHAVE}/${id}/${acao}`).then(r => r.json()) as Promise<AcessoSuporteDTO>,
    onSuccess: () => qc.invalidateQueries({ queryKey: [CHAVE] }),
  });
}
